










































































































































































































import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import { defineComponent, computed, ref, watch } from '~/utils/nuxt3-migration'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'
import { useNamespacedStore } from '~/compositions/store'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import CRadioButtonGroup from '~/components/shared/configurable/button/CRadioButtonGroup.vue'

type ElectricEnginePowerUnit = 'bhp' | 'kw'

export default defineComponent({
  components: { CRadioButtonGroup, CCustomSelect },
  props: facetHandlerComponentProps,
  setup(props) {
    const { changeParam, changeParams } = useClassifiedSearchFacet()
    const { getters } = useNamespacedStore(CLASSIFIED_SEARCH_NS)

    const batteryRangeFacet = computed(() =>
      getters('getFacetByName')('battery_range')
    )

    const batteryChargeTimeFacet = computed(() =>
      getters('getFacetByName')('battery_charge_time')
    )

    const batteryQuickChargeTimeFacet = computed(() =>
      getters('getFacetByName')('battery_quick_charge_time')
    )

    const batteryCapacityFacet = computed(() =>
      getters('getFacetByName')('battery_capacity')
    )

    const electricEnginePowerFacet = computed(() => {
      const enginePowerFacet = getters('getFacetByName')('engine_power')

      return enginePowerFacet?.type === 'ElectricEnginePowerSearchHandler'
        ? enginePowerFacet
        : null
    })

    const electricEngineSizeFacet = computed(() => {
      const engineSizeFacet = getters('getFacetByName')('engine_size')

      return engineSizeFacet?.type === 'KilowattSearchHandler'
        ? engineSizeFacet
        : null
    })

    const fuelType = ref(props.selected || [])
    const batteryRangeFrom = ref(
      batteryRangeFacet.value?.values?.selected?.low || null
    )
    const batteryRangeTo = ref(
      batteryRangeFacet.value?.values?.selected?.high || null
    )

    const batteryChargeTimeFrom = ref(
      batteryChargeTimeFacet.value?.values?.selected?.low || null
    )
    const batteryChargeTimeTo = ref(
      batteryChargeTimeFacet.value?.values?.selected?.high || null
    )

    const batteryQuickChargeTimeFrom = ref(
      batteryQuickChargeTimeFacet.value?.values?.selected?.low || null
    )
    const batteryQuickChargeTimeTo = ref(
      batteryQuickChargeTimeFacet.value?.values?.selected?.high || null
    )

    const batteryCapacityFrom = ref(
      batteryCapacityFacet.value?.values?.selected?.low || null
    )
    const batteryCapacityTo = ref(
      batteryCapacityFacet.value?.values?.selected?.high || null
    )
    const electricEnginePowerUnit = ref<ElectricEnginePowerUnit>(
      electricEnginePowerFacet.value && electricEngineSizeFacet.value
        ? 'kw'
        : 'bhp'
    )
    const electricEnginePowerFrom = ref(
      electricEnginePowerFacet.value?.values?.selected?.low || null
    )
    const electricEnginePowerTo = ref(
      electricEnginePowerFacet.value?.values?.selected?.high || null
    )

    const electricEngineSizeFrom = ref(
      electricEngineSizeFacet.value?.values?.selected?.low || null
    )
    const electricEngineSizeTo = ref(
      electricEngineSizeFacet.value?.values?.selected?.high || null
    )

    const fuelTypeOptions = computed(() =>
      props.searchables.map((s: any) => ({
        text: s.n,
        value: s.v,
        count: s.c
      }))
    )

    const batteryRangeFromOptions = computed(() =>
      batteryRangeFacet.value.searchables.values.map((s: any) => ({
        label: s.n,
        value: s.v,
        count: s.c,
        disabled:
          batteryRangeTo.value !== null &&
          parseFloat(s.v) > parseFloat(batteryRangeTo.value)
      }))
    )

    const batteryRangeToOptions = computed(() =>
      batteryRangeFacet.value.searchables.values.map((s: any) => ({
        label: s.n,
        value: s.v,
        count: s.c,
        disabled:
          batteryRangeFrom.value !== null &&
          parseFloat(s.v) < parseFloat(batteryRangeFrom.value)
      }))
    )

    const batteryChargeTimeFromOptions = computed(() =>
      batteryChargeTimeFacet.value.searchables.values.map((s: any) => ({
        label: s.n,
        value: s.v,
        count: s.c,
        disabled:
          batteryChargeTimeTo.value !== null &&
          parseFloat(s.v) > parseFloat(batteryChargeTimeTo.value)
      }))
    )

    const batteryChargeTimeToOptions = computed(() =>
      batteryChargeTimeFacet.value.searchables.values.map((s: any) => ({
        label: s.n,
        value: s.v,
        count: s.c,
        disabled:
          batteryChargeTimeFrom.value !== null &&
          parseFloat(s.v) < parseFloat(batteryChargeTimeFrom.value)
      }))
    )

    const batteryQuickChargeTimeFromOptions = computed(() =>
      batteryQuickChargeTimeFacet.value.searchables.values.map((s: any) => ({
        label: s.n,
        value: s.v,
        count: s.c,
        disabled:
          batteryQuickChargeTimeTo.value !== null &&
          parseFloat(s.v) > parseFloat(batteryQuickChargeTimeTo.value)
      }))
    )

    const batteryQuickChargeTimeToOptions = computed(() =>
      batteryQuickChargeTimeFacet.value.searchables.values.map((s: any) => ({
        label: s.n,
        value: s.v,
        count: s.c,
        disabled:
          batteryQuickChargeTimeFrom.value !== null &&
          parseFloat(s.v) < parseFloat(batteryQuickChargeTimeFrom.value)
      }))
    )

    const batteryCapacityFromOptions = computed(() =>
      batteryCapacityFacet.value.searchables.values.map((s: any) => ({
        label: s.n,
        value: s.v,
        count: s.c,
        disabled:
          batteryCapacityTo.value !== null &&
          parseFloat(s.v) > parseFloat(batteryCapacityTo.value)
      }))
    )

    const batteryCapacityToOptions = computed(() =>
      batteryCapacityFacet.value.searchables.values.map((s: any) => ({
        label: s.n,
        value: s.v,
        count: s.c,
        disabled:
          batteryCapacityFrom.value !== null &&
          parseFloat(s.v) < parseFloat(batteryCapacityFrom.value)
      }))
    )

    const electricEnginePowerUnitOptions = computed<
      Array<{ label: string; value: ElectricEnginePowerUnit; variant: string }>
    >(() => [
      {
        label: electricEnginePowerFacet.value.humanName,
        value: 'bhp',
        variant: 'warning'
      },
      {
        label: electricEngineSizeFacet.value.humanName,
        value: 'kw',
        variant: 'warning'
      }
    ])

    const electricEnginePowerFromOptions = computed(() =>
      electricEnginePowerFacet.value.searchables.values.map((s: any) => ({
        label: s.n,
        value: s.v,
        count: s.c,
        disabled:
          electricEnginePowerTo.value !== null &&
          parseFloat(s.v) > parseFloat(electricEnginePowerTo.value)
      }))
    )

    const electricEnginePowerToOptions = computed(() =>
      electricEnginePowerFacet.value.searchables.values.map((s: any) => ({
        label: s.n,
        value: s.v,
        count: s.c,
        disabled:
          electricEnginePowerFrom.value !== null &&
          parseFloat(s.v) < parseFloat(electricEnginePowerFrom.value)
      }))
    )

    const electricEngineSizeFromOptions = computed(() =>
      electricEngineSizeFacet.value.searchables.values.map((s: any) => ({
        label: s.n,
        value: s.v,
        count: s.c,
        disabled:
          electricEngineSizeTo.value !== null &&
          parseFloat(s.v) > parseFloat(electricEngineSizeTo.value)
      }))
    )

    const electricEngineSizeToOptions = computed(() =>
      electricEngineSizeFacet.value.searchables.values.map((s: any) => ({
        label: s.n,
        value: s.v,
        count: s.c,
        disabled:
          electricEngineSizeFrom.value !== null &&
          parseFloat(s.v) < parseFloat(electricEngineSizeFrom.value)
      }))
    )

    const emptyElectricFacetsParams = [
      { name: 'battery_range-from', value: null },
      { name: 'battery_range-to', value: null },
      { name: 'battery_charge_time-from', value: null },
      { name: 'battery_charge_time-to', value: null },
      { name: 'battery_quick_charge_time-from', value: null },
      { name: 'battery_quick_charge_time-to', value: null },
      { name: 'battery_capacity-from', value: null },
      { name: 'battery_capacity-to', value: null },
      { name: 'engine_power-from', value: null },
      { name: 'engine_power-to', value: null },
      { name: 'engine_size-from', value: null },
      { name: 'engine_size-to', value: null }
    ]

    watch(
      () => props.selected,
      (newValue: number[]) => {
        fuelType.value = newValue
      }
    )

    watch(batteryRangeFacet, newFacet => {
      batteryRangeFrom.value = newFacet?.values?.selected?.low || null
      batteryRangeTo.value = newFacet?.values?.selected?.high || null
    })

    watch(batteryChargeTimeFacet, newFacet => {
      batteryChargeTimeFrom.value = newFacet?.values?.selected?.low || null
      batteryChargeTimeTo.value = newFacet?.values?.selected?.high || null
    })

    watch(batteryQuickChargeTimeFacet, newFacet => {
      batteryQuickChargeTimeFrom.value = newFacet?.values?.selected?.low || null
      batteryQuickChargeTimeTo.value = newFacet?.values?.selected?.high || null
    })

    watch(batteryCapacityFacet, newFacet => {
      batteryCapacityFrom.value = newFacet?.values?.selected?.low || null
      batteryCapacityTo.value = newFacet?.values?.selected?.high || null
    })

    watch(
      [electricEnginePowerFacet, electricEngineSizeFacet],
      ([newElectricEnginePowerFacet, newElectricEngineSizeFacet]) => {
        if (newElectricEnginePowerFacet && !newElectricEngineSizeFacet) {
          electricEnginePowerUnit.value = 'bhp'
        } else if (!newElectricEnginePowerFacet && newElectricEngineSizeFacet) {
          electricEnginePowerUnit.value = 'kw'
        }

        electricEnginePowerFrom.value =
          newElectricEnginePowerFacet?.values?.selected?.low || null
        electricEnginePowerTo.value =
          newElectricEnginePowerFacet?.values?.selected?.high || null

        electricEngineSizeFrom.value =
          newElectricEngineSizeFacet?.values?.selected?.low || null
        electricEngineSizeTo.value =
          newElectricEngineSizeFacet?.values?.selected?.high || null
      }
    )

    function onClearButtonClick() {
      fuelType.value = []
      batteryRangeFrom.value = null
      batteryRangeTo.value = null
      batteryChargeTimeFrom.value = null
      batteryChargeTimeTo.value = null
      batteryQuickChargeTimeFrom.value = null
      batteryQuickChargeTimeTo.value = null
      batteryCapacityFrom.value = null
      batteryCapacityTo.value = null
      electricEnginePowerFrom.value = null
      electricEnginePowerTo.value = null
      electricEngineSizeFrom.value = null
      electricEngineSizeTo.value = null

      changeParams([
        {
          name: props.urlArgNames[0],
          value: null
        },
        ...emptyElectricFacetsParams
      ])
    }

    function onFuelTypeChange(value: number[]) {
      changeParams([
        {
          name: props.urlArgNames[0],
          value
        },
        ...emptyElectricFacetsParams
      ])
    }

    function onBatteryRangeFromChange(value: number) {
      changeParam({
        name: 'battery_range-from',
        value
      })
    }

    function onBatteryRangeToChange(value: number) {
      changeParam({
        name: 'battery_range-to',
        value
      })
    }

    function onBatteryChargeTimeFromChange(value: number) {
      changeParam({
        name: 'battery_charge_time-from',
        value
      })
    }

    function onBatteryChargeTimeToChange(value: number) {
      changeParam({
        name: 'battery_charge_time-to',
        value
      })
    }

    function onBatteryQuickChargeTimeFromChange(value: number) {
      changeParam({
        name: 'battery_quick_charge_time-from',
        value
      })
    }

    function onBatteryQuickChargeTimeToChange(value: number) {
      changeParam({
        name: 'battery_quick_charge_time-to',
        value
      })
    }

    function onBatteryCapacityFromChange(value: number) {
      changeParam({
        name: 'battery_capacity-from',
        value
      })
    }

    function onBatteryCapacityToChange(value: number) {
      changeParam({
        name: 'battery_capacity-to',
        value
      })
    }

    function onElectricEnginePowerFromChange(value: number) {
      changeParam({
        name: 'engine_power-from',
        value
      })
    }

    function onElectricEnginePowerToChange(value: number) {
      changeParam({
        name: 'engine_power-to',
        value
      })
    }

    function onElectricEngineSizeFromChange(value: number) {
      changeParam({
        name: 'engine_size-from',
        value
      })
    }

    function onElectricEngineSizeToChange(value: number) {
      changeParam({
        name: 'engine_size-to',
        value
      })
    }

    function onElectricEnginePowerUnitChange(newUnit: ElectricEnginePowerUnit) {
      if (newUnit === 'bhp') {
        electricEngineSizeFrom.value = null
        electricEngineSizeTo.value = null
        changeParams([
          {
            name: 'engine_size-from',
            value: null
          },
          {
            name: 'engine_size-to',
            value: null
          }
        ])
      } else {
        electricEnginePowerFrom.value = null
        electricEnginePowerTo.value = null
        changeParams([
          {
            name: 'engine_power-from',
            value: null
          },
          {
            name: 'engine_power-to',
            value: null
          }
        ])
      }
    }

    return {
      fuelTypeOptions,
      fuelType,
      batteryRangeFacet,
      batteryChargeTimeFacet,
      batteryQuickChargeTimeFacet,
      batteryCapacityFacet,
      batteryRangeFromOptions,
      batteryRangeToOptions,
      batteryRangeFrom,
      batteryRangeTo,
      batteryChargeTimeFromOptions,
      batteryChargeTimeToOptions,
      batteryChargeTimeFrom,
      batteryChargeTimeTo,
      batteryQuickChargeTimeFromOptions,
      batteryQuickChargeTimeToOptions,
      batteryQuickChargeTimeFrom,
      batteryQuickChargeTimeTo,
      batteryCapacityFromOptions,
      batteryCapacityToOptions,
      batteryCapacityFrom,
      batteryCapacityTo,
      electricEnginePowerUnit,
      electricEnginePowerFacet,
      electricEnginePowerUnitOptions,
      electricEngineSizeFacet,
      electricEnginePowerFromOptions,
      electricEnginePowerToOptions,
      electricEnginePowerFrom,
      electricEnginePowerTo,
      electricEngineSizeFromOptions,
      electricEngineSizeToOptions,
      electricEngineSizeFrom,
      electricEngineSizeTo,
      onFuelTypeChange,
      onClearButtonClick,
      onBatteryRangeFromChange,
      onBatteryRangeToChange,
      onBatteryChargeTimeFromChange,
      onBatteryChargeTimeToChange,
      onBatteryQuickChargeTimeFromChange,
      onBatteryQuickChargeTimeToChange,
      onBatteryCapacityFromChange,
      onBatteryCapacityToChange,
      onElectricEnginePowerFromChange,
      onElectricEnginePowerToChange,
      onElectricEngineSizeFromChange,
      onElectricEngineSizeToChange,
      onElectricEnginePowerUnitChange
    }
  }
})
